import React from 'react';
import { useLeadStore } from '@/store/useLeadStore';
import { USER_PROFILES_SALE, USER_PROFILES_RENTAL } from '@/utils/constants';
import { Button } from '../UI/Button';

export const Step4UserProfile: React.FC = () => {
  const { formData, nextStep, previousStep } = useLeadStore();
  const [selectedProfile, setSelectedProfile] = React.useState<string | null>(null);

  // Determine which profiles to show based on estimation type
  const profiles = formData.estimationType === 'prix' 
    ? USER_PROFILES_SALE 
    : USER_PROFILES_RENTAL;

  const handleSelect = (profileValue: string) => {
    setSelectedProfile(profileValue);
    // Auto-advance after selection
    setTimeout(() => nextStep(), 400);
  };

  return (
    <div className="animate-fade-in">
      <h2 className="text-[28px] font-light tracking-tight mb-2">Votre profil</h2>
      <p className="text-sm text-secondary mb-10">
        Vous êtes...
      </p>

      <div className="grid grid-cols-2 gap-3 mb-3">
        {profiles.slice(0, 2).map((profile) => (
          <div
            key={profile.value}
            className={`border border-border py-8 px-5 text-center cursor-pointer transition-all duration-300 text-sm font-medium ${
              selectedProfile === profile.value
                ? 'border-primary bg-[#FAFAFA]'
                : 'hover:border-primary'
            }`}
            onClick={() => handleSelect(profile.value)}
          >
            <span className="block text-2xl mb-3">{profile.icon}</span>
            {profile.title}
          </div>
        ))}
      </div>

      {/* Third profile centered in second row */}
      {profiles.length === 3 && (
        <div className="flex justify-center mb-10">
          <div
            className={`border border-border py-8 px-5 text-center cursor-pointer transition-all duration-300 text-sm font-medium w-[calc(50%-6px)] ${
              selectedProfile === profiles[2].value
                ? 'border-primary bg-[#FAFAFA]'
                : 'hover:border-primary'
            }`}
            onClick={() => handleSelect(profiles[2].value)}
          >
            <span className="block text-2xl mb-3">{profiles[2].icon}</span>
            {profiles[2].title}
          </div>
        </div>
      )}

      <div className="flex gap-3">
        <Button variant="secondary" onClick={previousStep}>
          Retour
        </Button>
      </div>
    </div>
  );
};
